import { render, staticRenderFns } from "./AccessesList.vue?vue&type=template&id=106a1352&"
import script from "./AccessesList.ts?vue&type=script&lang=ts&"
export * from "./AccessesList.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports